import { postJson } from 'requests/http';
import type { CompanyLead } from 'packages/signup/components/signupForm/types';
import {
  trackCompanyLeadFormError,
  trackCompanyLeadFormSubmitted,
  trackLeadFormSubmissionForPixel,
} from './track';
import type {
  LeadFormDetailsValues,
  OnLeadFormFailureProps,
  OnLeadFormSubmitProps,
  OnLeadFormSuccessProps,
} from './types';

const formatCompanyLead = (
  data: LeadFormDetailsValues,
  submittedFrom: string,
  leadOrigin: string,
  leadOriginSubtype: string
): CompanyLead => ({
  first_name: data.firstName || '',
  last_name: data.lastName || '',
  company_name: data.companyName || '',
  email: data.email || '',
  number_employees: Number(data.numberEmployees) || 0,
  phone: data.phone || '',
  industry: data.industry || 'Other',
  submitted_from: submittedFrom,
  lead_origin: leadOrigin || '',
  lead_origin_subtype: leadOriginSubtype || '',
});

export async function onSubmitLeadForm({
  values,
  formikOpts,
  onFailure,
  onSuccess,
  submittedFrom,
  leadOrigin,
  leadOriginSubtype,
}: OnLeadFormSubmitProps) {
  try {
    const response = await postJson(
      '/invite/company',
      formatCompanyLead(values, submittedFrom, leadOrigin, leadOriginSubtype)
    );

    // If new lead is created send this event on submit after validation - Instant Demo Lead Form
    trackLeadFormSubmissionForPixel();
    return onSuccess({ response, values, submittedFrom });
  } catch (error) {
    const { status, responseText } = error as { status: string; responseText: string };
    formikOpts?.setStatus({ unknownError: true });
    formikOpts?.setSubmitting(false);
    return onFailure({ status, responseText, submittedFrom });
  }
}

export const onLeadFormFailure = ({
  responseText,
  status,
  submittedFrom,
}: OnLeadFormFailureProps) => {
  trackCompanyLeadFormError({ submittedFrom, responseText, status });
};

export const onLeadFormSuccess = ({ submittedFrom, values }: OnLeadFormSuccessProps) => {
  trackCompanyLeadFormSubmitted({ submittedFrom, values });
};
